import _each from "lodash/each";
import store from "~/js/store/store";
import { gsap, Quint, Circ, Cubic } from "gsap";
export default class LazyImage {
  constructor() {
    this.setup();
    this.setupLazyContainer();
    this.setupLazyClass();
  }
  setup() {
    const lazys = document.querySelectorAll(".js-lazy");
    _each(lazys, (elm, index) => {
      const delay = elm.getAttribute("data-delay") || 0;
      const trigger = elm.getAttribute("data-trigger") || elm;
      const duration = elm.getAttribute("data-duration") || 0.6;
      const start = elm.getAttribute("data-start") || "top 86%";
      const end = elm.getAttribute("data-end") || "bottom 10%";
      gsap.set(elm, {
        opacity: 0,
        y: 30
      });
      gsap.to(elm, {
        y: 0,
        opacity: 1,
        duration,
        delay,
        ease: Cubic.easeOut,
        scrollTrigger: {
          trigger,
          start,
          end,
          onEnter: () => {}
        }
      });
    });
  }
  setupLazyClass() {
    const lazys = document.querySelectorAll(".js-lazyclass");
    _each(lazys, (elm, index) => {
      const trigger = elm.getAttribute("data-trigger") || elm;
      const start = elm.getAttribute("data-start") || "top 100%";
      const end = elm.getAttribute("data-end") || "top 100%";

      gsap.to(elm, {
        scrollTrigger: {
          trigger,
          start,
          end,
          once: true,
          onEnter: () => {
            elm.classList.add("appear");
          }
        }
      });
    });
  }

  setupLazyContainer() {
    const lazys = document.querySelectorAll(".js-lazycontainer");
    _each(lazys, (elm) => {
      const children = elm.children;
      _each(children, (child, index) => {});
    });
  }
}
